<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p">SIDE ONE<br/>Play It Loud</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?11a671f8